<template>
    <Slide :title="title" :subtitle="subtitle">
        <div>
            <p class="cr:font-semibold cr:mb-3 cr:text-lg">Please verify your email address</p>
            <p>We've sent a verification email to <strong>{{ registrationStore.registeringCompany.email }}</strong>.
              <br/>
              Please verify your email address by following the verification link we sent you.
              Once verified, you'll be able to view lead prices and set up your account.</p>
        </div>
    </Slide>
</template>

<script setup lang="ts">

import Slide from "@/components/slides/Slide.vue";
import {useRegistrationStore} from "@/stores/registration.ts";

const registrationStore = useRegistrationStore();
const props = defineProps({
    title: {
        type: String,
        default: 'Verification successful'
    },
    subtitle: {
        type: String,
        defualt: ''
    }
});

</script>